import { useIsMobile } from '#src/app/shared/hooks/userAgent';

export function useFacebookMessengerAvailable(): boolean {
	return useIsMobile();
}
